import { jsx as _jsx } from "react/jsx-runtime";
import { useLayoutEffect, useRef } from "react";
import { useSignal } from "@preact/signals";
import classNames from "classnames";
import DropDownMenu from "../DropDownMenu";
import Icon from "../Icon";
import style from "./style.module.scss";
export default function TabBar(props) {
    const { options, selected, onChange, collapsable } = props;
    const tabsWidth = useSignal(0);
    const displayMode = useSignal("tabbar");
    const ref = useRef(null);
    useLayoutEffect(() => {
        if (collapsable) {
            if (ref.current && tabsWidth.value === 0) {
                tabsWidth.value = ref.current.offsetWidth;
            }
            checkLayoutState();
            window.addEventListener("resize", checkLayoutState);
            return () => {
                window.removeEventListener("resize", checkLayoutState);
            };
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tabsWidth.value, collapsable]);
    function checkLayoutState() {
        if (ref.current && ref.current.parentElement) {
            if (tabsWidth.value > ref.current.parentElement.offsetWidth - 20) {
                displayMode.value = "dropdown";
            }
            else {
                displayMode.value = "tabbar";
            }
        }
    }
    const optionList = [];
    if (displayMode.value === "tabbar") {
        //Render as tab bar
        options.forEach((option) => {
            let tabBarItemActive = "";
            if (selected === option.value) {
                tabBarItemActive = "tab-bar__item--active";
            }
            optionList.push(_jsx("button", { type: "button", role: "tab", "aria-selected": selected === option.value, className: classNames(style["tab-bar__item"], style[tabBarItemActive]), onClick: () => {
                    onTabClicked(option.value);
                }, children: option.label }));
        });
    }
    else if (displayMode.value === "dropdown") {
        //Render as dropdown
        const optionsDD = [];
        options.forEach((option) => {
            optionsDD.push(option);
        });
        optionList.push(_jsx(DropDownMenu, { selected: selected, sections: [{ options: optionsDD }], buttonClassName: style["tab-bar__drop-down-button"], customIcon: _jsx(Icon, { name: "caret--thin--down" }), onChange: (MenuOption) => {
                onTabClicked(MenuOption.value);
            } }));
    }
    const absMode = collapsable && tabsWidth.value === 0;
    //User has clicked on a new tab.
    function onTabClicked(newOptionValue) {
        onChange(newOptionValue);
    }
    return (_jsx("div", { role: "tablist", className: style["tab-bar"], children: _jsx("div", { className: classNames(style["tab-bar__inner"], style[absMode ? "tab-bar__inner--abs" : ""]), ref: ref, children: optionList }) }));
}
